import { type FC } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import dibsCss from 'dibs-css';

import styles from './UserRecommendations.module.css';

export type UserRecommendationsTitleAlign = 'left' | 'center';

type UserRecommendationsTitleProps = {
    titleAlign?: UserRecommendationsTitleAlign;
    isMobile: boolean;
    isLoading?: boolean;
};

export const UserRecommendationsTitle: FC<UserRecommendationsTitleProps> = ({
    titleAlign = 'center',
    isMobile,
    isLoading,
}) => {
    return (
        <div
            className={classnames(dibsCss.mxAuto, {
                [dibsCss.sassyAnimateLoadingShimmer]: isLoading,
                [styles.shimmerTitleMobile]: isLoading && isMobile,
                [styles.shimmerTitle]: isLoading && !isMobile,
                [dibsCss.sassyFontHeaderLarge]: isMobile,
                [dibsCss.sassyFontHeaderXLarge]: !isMobile,
                [dibsCss.textLeft]: titleAlign === 'left',
                [dibsCss.textCenter]: titleAlign === 'center',
            })}
        >
            <span className={classnames(isLoading && dibsCss.invisible)}>
                <FormattedMessage
                    id="UserRecommendations.titleItalic"
                    defaultMessage="You'll Want <italicWrapper>All of These</italicWrapper>"
                    values={{
                        italicWrapper: chunks => (
                            <span
                                className={
                                    isMobile
                                        ? dibsCss.sassyFontHeaderLargeItalic
                                        : dibsCss.sassyFontHeaderXLargeItalic
                                }
                            >
                                {chunks}
                            </span>
                        ),
                    }}
                />
            </span>
        </div>
    );
};
